import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const UserRoundCheck: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 21a8 8 0 0 1 13.292-6' }],
    ['circle', { cx: '10', cy: '8', r: '5' }],
    ['path', { d: 'm16 19 2 2 4-4' }],
  ],
];

export default UserRoundCheck;
